import {
    onMounted, Ref, watch, inject, ref
} from 'vue';
import type { InjectedPagePreferences } from '@agyletime/vue-3-common/src/typings/pagePreference';

interface SelectedViewFacetOptions {
    pagePreferences: InjectedPagePreferences | undefined;
    activeTable: string;
    facetId: string;
    resetFilters: Ref<boolean>;
    onSelectedViewFacetChange: (value: unknown) => void;
}

export function useSelectedViewFacet({ pagePreferences, activeTable, facetId, onSelectedViewFacetChange }: SelectedViewFacetOptions) {
    const isLoadingView = inject('isLoadingView', ref(false)) as Ref<boolean>;
    const updateSelectedViewFacet = (useSelected = false) => {
        const source = useSelected ? pagePreferences?.selected.value : pagePreferences?.intermediate.value;
        const selectedViewFacets = JSON.parse(JSON.stringify(source?.filter?.facets ?? {}));
        const selectedViewFacetId = selectedViewFacets[activeTable]?.[facetId];
        if (selectedViewFacetId?.value || (source && Object.keys(source).length > 0 ))
        {
            onSelectedViewFacetChange(selectedViewFacetId);
        }
        
    };

    onMounted(() => updateSelectedViewFacet());

    watch(
        () => pagePreferences?.intermediate.value,
        () => updateSelectedViewFacet()
    );

    watch(isLoadingView, (newValue) => {
        if (newValue) {
            updateSelectedViewFacet(true);
        }
    }, { immediate: true });
}
